import { FIELD_COMPONENTS } from 'refunds/constants/FieldComponents'
import type { FormField } from 'refunds/services/getCountryFields/normalization'
import type { BankDataInfo } from 'refunds/types/refundData'

const parseDateValue = (date: string) =>
	new Date(date).toISOString().split('T')[0]

export const normalizeBankDataFormValues = (
	fieldsConfig: FormField[],
	fieldValues: BankDataInfo
): BankDataInfo => {
	return Object.entries(fieldValues).reduce((prev, [fieldName, fieldValue]) => {
		const { component, forceUpperCase } =
			fieldsConfig.find(({ field: fName }) => fName === fieldName) ?? {}
		return {
			...prev,
			// Format to uppercase if necessary
			...{
				[fieldName]:
					forceUpperCase && typeof fieldValue === 'string'
						? fieldValue.toUpperCase()
						: fieldValue,
			},
			// Format date to ISO format if Date field
			...(component === FIELD_COMPONENTS.DATE_INPUT && {
				[fieldName]: parseDateValue(fieldValue),
			}),
		}
	}, {})
}
